import { Flex, Button, Dropdown } from "antd";
import { BlobProvider } from "@react-pdf/renderer";

import PrinterIcon from "@/icons/PrinterIcon";
import DownloadIcon from "@/icons/DownloadIcon";
import FilePdfIcon from "@/icons/FilePdfIcon";

import PDF from "../PDF";

// Список доступных форматов экспорта в выпадающем меню
const EXPORT_MENU_ITEMS = [
  { key: "excel", label: "Excel" },
  { key: "csv", label: "CSV" },
];

/**
 * ReportActions — панель действий для результатов отчёта.
 * Содержит:
 *  - Экспорт (Excel/CSV)
 *  - Генерацию и просмотр PDF
 *  - Печать текущей страницы
 *
 * props:
 *  - sectionsData: данные секций отчёта, используются для генерации PDF
 *  - reportName: название отчёта (заголовок документа PDF)
 *  - onExport(type): колбэк экспорта, type: 'excel' | 'csv'
 *  - onPrint(): колбэк печати страницы
 *  - exportPending: флаг загрузки на время экспорта
 */
const ReportActions = ({
  sectionsData,
  reportName,
  onExport,
  onPrint,
  exportPending,
}) => {
  return (
    <Flex gap={8} className="not-print">
      {/* Кнопка "Скачать" с меню выбора формата экспорта */}
      <Dropdown
        menu={{
          items: EXPORT_MENU_ITEMS,
          onClick: ({ key }) => onExport(key),
        }}
        trigger={["click"]}
      >
        <Button type="primary" icon={<DownloadIcon />} loading={exportPending}>
          Скачать
        </Button>
      </Dropdown>

      {/* Генерация PDF в памяти через @react-pdf/renderer и открытие в новой вкладке */}
      <BlobProvider document={<PDF data={sectionsData} title={reportName} />}>
        {({ blob, url, loading }) => (        
          <Button
            loading={!blob}
            icon={<FilePdfIcon />}
            onClick={() => {
              // Открываем PDF, когда blob/url готовы
              if (loading || !blob || !url) return;
              window.open(url);
            }}
          >
            PDF
          </Button>
        )}
      </BlobProvider>

      {/* Запуск печати: логика подготовки (раскрытие строк и т.д.) находится в родительском компоненте */}
      <Button icon={<PrinterIcon />} onClick={onPrint}>
        Печать
      </Button>
    </Flex>
  );
};

export default ReportActions;
